import { Alert, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../../components/ConfirmDialog';

/**
 * Confirms reconnecting a login to this resident. Warns that payment methods
 * will be removed and CredBuild stays on the previous lease.
 */
export default function RebindPersonConfirmModal({
  onClose,
  onSubmit,
  loading,
  userEmail,
  sourcePersonName,
  targetPersonName,
  activePaymentMethodCount = 0,
  autopayActive = false,
  hasOpenCredBuild = false,
  requireMoveLoginPrefix = false,
}) {
  const { t } = useTranslation();
  const [reason, setReason] = useState(requireMoveLoginPrefix ? 'MOVE_LOGIN ' : '');
  const trimmed = reason.trim();
  const reasonOk = trimmed.length >= 3 && trimmed.length <= 500 && (!requireMoveLoginPrefix || trimmed.startsWith('MOVE_LOGIN'));

  const body = (
    <Stack gap={1.5} sx={{ textAlign: 'left' }}>
      <Typography variant="body2" color="text.secondary">
        {t('lease.resident.rebindBody', {
          email: userEmail,
          from: sourcePersonName || t('lease.resident.rebindUnknownPerson'),
          to: targetPersonName,
        })}
      </Typography>
      {(activePaymentMethodCount > 0 || autopayActive) && (
        <Alert severity="warning">{t('lease.resident.rebindPaymentWarning', { count: activePaymentMethodCount })}</Alert>
      )}
      {hasOpenCredBuild && <Alert severity="info">{t('lease.resident.rebindCredBuildWarning')}</Alert>}
      {requireMoveLoginPrefix && <Alert severity="warning">{t('lease.resident.rebindMoveLoginRequired')}</Alert>}
      <TextField
        fullWidth
        multiline
        minRows={2}
        label={t('lease.resident.rebindReasonLabel')}
        value={reason}
        onChange={e => setReason(e.target.value)}
        helperText={t('lease.resident.rebindReasonHint')}
      />
    </Stack>
  );

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      title={t('lease.resident.rebindTitle')}
      body={body}
      cancelLabel={t('common.cancel')}
      confirmLabel={t('lease.resident.rebindConfirm')}
      onConfirm={() => {
        if (!reasonOk) return;
        onSubmit(trimmed);
      }}
      loading={loading}
      destructive
    />
  );
}
